var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSysLogs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m392 512h-272c-66.168 0-120-53.832-120-120v-272c0-66.168 53.832-120 120-120h272c66.168 0 120 53.832 120 120v272c0 66.168-53.832 120-120 120zm-272-472c-44.112 0-80 35.888-80 80v272c0 44.112 35.888 80 80 80h272c44.112 0 80-35.888 80-80v-272c0-44.112-35.888-80-80-80zm304 216c0-11.046-8.954-20-20-20h-141c-11.046 0-20 8.954-20 20s8.954 20 20 20h141c11.046 0 20-8.954 20-20zm-70-77c0-11.046-8.954-20-20-20h-187c-11.046 0-20 8.954-20 20s8.954 20 20 20h187c11.046 0 20-8.954 20-20zm-143-78c0-11.046-8.954-20-20-20h-84c-11.046 0-20 8.954-20 20s8.954 20 20 20h84c11.046 0 20-8.954 20-20zm183 233c0-11.046-8.954-20-20-20h-167c-11.046 0-20 8.954-20 20s8.954 20 20 20h167c11.046 0 20-8.954 20-20zm27 78c0-11.046-8.954-20-20-20h-44c-11.046 0-20 8.954-20 20s8.954 20 20 20h44c11.046 0 20-8.954 20-20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSysLogs);
export default __webpack_public_path__ + "static/media/sys-logs.dc9407ac5cc29785b9ebc3f1502e787c.svg";
export { ForwardRef as ReactComponent };